import { CustomButton, CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IVacancyTypeFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/center/parameters/vacancyType/VacancyTypeMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';

type Props = {
  onSubmit: any,
  meta: IVacancyTypeFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const VacancyTypeFormUI = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          sm: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(2, 1fr)',
        }}
        gap={10}
        mb={5}
      >
        <CustomFormControl
          label={meta.oneId.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.oneId.name]}
        >
          <CustomTextInput
            meta={meta.oneId}
            register={register(meta.oneId.name)}
            hasError={errors[meta.oneId.name]}
          />
        </CustomFormControl>
        <CustomFormControl
          label={meta.name.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.name.name]}
        >
          <CustomTextInput
            meta={meta.name}
            register={register(meta.name.name)}
            hasError={errors[meta.name.name]}
          />
        </CustomFormControl>
      </CC.Grid>

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default VacancyTypeFormUI;
